import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {useFormik} from 'formik';
import {validate} from '../../utils/validate';
import ModalContainer from '../../../_common/components/ModalContainer';
import ButtonAction from '../../../_common/components/ButtonAction';
import ContactForm from '../ContactForm';
import {can} from '../../../_common/components/Permissions';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import {showGlobalMessage} from '../../../_common/components/GlobalMessage/actions/showGlobalMessage';
import {messages as M} from '../../../../../_metronic/i18n/messages';
import {addEditContact} from '../../actions/ContactsActions';

export default function PopupAddContact({
                                          buttonVariant = 'link',
                                          customLabel = '',
                                          formikProps,
                                          containerClassnames = ''
                                        }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);

  const formik = useFormik({
    initialValues: {
      contactID: -1,
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      job: '',
      organization: '',
      address: '',
      statusID: 1
    },
    validate: values => validate(values, formik.initialValues),
    onSubmit: () => {
    },
  });

  const addContact = async () => {
    try {
      const result = await dispatch(addEditContact(formik.values, !Boolean(formikProps)));
      if (formikProps && result) {
        formikProps.setFieldValue('contacts', [result]);
      }
      formik.resetForm();
      await dispatch(showGlobalMessage('success', M['0']));
    } catch (e) {
      console.error('addContact:', e);
    }
  };

  return (
    <div className={containerClassnames}>
      <ButtonAction
        variant={buttonVariant}
        onClick={handleShowModal}
        disabled={!can(T.FULL, S.CONTACTS_PAGE)}
        label={customLabel ||
          [
            intl.formatMessage({id: 'contacts-popup-add-row', defaultMessage: 'Add contact'}),
            '+'
          ].filter(Boolean).join(' ')
        }
      />
      <ModalContainer show={show} onHide={handleCloseModal} customClassnames={'pt-5'}>
        <ContactForm
          onSubmit={addContact}
          handleCloseModal={handleCloseModal}
          {...formik}
        />
      </ModalContainer>
    </div>
  );
}
